import { ArticleSearch, ProductArticles } from '@article/const';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { ArticleState, StateWithArticle } from '../article-state';
import { getArticleState } from './feature.selector';

export const getArticlesSearchState: MemoizedSelector<
  StateWithArticle,
  StateUtils.LoaderState<ArticleSearch>
> = createSelector(getArticleState, (state: ArticleState) => state.articlesSearch);

export const getArticlesSearchValue: MemoizedSelector<StateWithArticle, ArticleSearch> = createSelector(
  getArticlesSearchState,
  (state: StateUtils.LoaderState<ArticleSearch>) => StateUtils.loaderValueSelector(state),
);

export const getArticlesSearchLoading: MemoizedSelector<StateWithArticle, boolean> = createSelector(
  getArticlesSearchState,
  (state: StateUtils.LoaderState<ArticleSearch>) => StateUtils.loaderLoadingSelector(state),
);

export const getArticlesSearchError: MemoizedSelector<StateWithArticle, boolean> = createSelector(
  getArticlesSearchState,
  (state: StateUtils.LoaderState<ArticleSearch>) => StateUtils.loaderErrorSelector(state),
);

export const getArticlesSearchSuccess: MemoizedSelector<StateWithArticle, boolean> = createSelector(
  getArticlesSearchState,
  (state: StateUtils.LoaderState<ArticleSearch>) => StateUtils.loaderSuccessSelector(state),
);

export const getProductArticlesState: MemoizedSelector<
  StateWithArticle,
  StateUtils.EntityLoaderState<ProductArticles>
> = createSelector(getArticleState, (state: ArticleState) => state.productArticles);

export const getProductArticlesValue = (code: string): MemoizedSelector<StateWithArticle, ProductArticles> =>
  createSelector(getProductArticlesState, (state) => StateUtils.entityValueSelector(state, code));
